export class BefungeError extends Error {}
